<template>
  <section class="section-base form-section-base form-base">
    <div class="form-section-base__title mb-4">
      Доказательства, подтверждающие наличие обстоятельств, достаточных для
      получения выписки
    </div>

    <v-container>
      <component
        :is="Form"
        :loading-next="loadingNext"
        @prev="$emit(StepDirection.PREV, $event)"
        @next="$emit(StepDirection.NEXT, $event)"
      />
    </v-container>
  </section>
</template>

<script>
import { ServicesModule } from '@/store/modules/services';
import DocsForm from '@/components/services/EgrnConfirm/Proof/DocsForm';
import DealForm from '@/components/services/EgrnConfirm/Proof/DealForm';
import { StepDirection } from '@/types/services';

export default {
  name: 'Proof',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isApplicantRightholder() {
      return Boolean(ServicesModule.statement.subjects.applicantRightholder);
    },
    Form() {
      return this.isApplicantRightholder ? DealForm : DocsForm;
    },
  },
  data: () => ({
    StepDirection,
  }),
};
</script>
